export const ourPartners = {
  title: "External validation",
};
